import { Component, OnDestroy, OnInit } from '@angular/core';
import { IHangfireECSTaskInfo } from '../../interfaces/system-settings/hangfire-ecs/hangfire-ecs-task-info';
import { Message } from '../../classes/Message';
import { HangfireRecurringJobService } from '../../services/hangfire-recurring-job.service';
import { MessageService } from 'primeng';
import { EnvironmentService } from '../../services';

@Component({
  selector: 'app-hangfire-ecs-manager',
  templateUrl: './hangfire-ecs-manager.component.html',
  styleUrls: ['./hangfire-ecs-manager.component.css'],
})
export class HangfireEcsManagerComponent implements OnInit, OnDestroy {
  public modifyHangfireECSServiceDisabled: boolean = false;
  public hangfireECSServiceOverview: IHangfireECSTaskInfo[];
  public hangfireECSCurrentTaskCount: number = 0;
  public featureEnabled: boolean = false;
  private intervalId: any;

  constructor(
    private hangfireService: HangfireRecurringJobService,
    private messageService: MessageService,
    private environmentService: EnvironmentService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.featureEnabled = this.environmentService.isSandboxOrUAT();

    if (this.featureEnabled) {
      void this.getHangfireECSServiceOverview();
      void this.getHangfireECSTaskCount();

      this.intervalId = setInterval(() => {
        this.getHangfireECSServiceOverview();
        this.getHangfireECSTaskCount();
      }, 5000);
    }
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  async onStartStopHangfireECSServiceClick() {
    this.modifyHangfireECSServiceDisabled = true;
    try {
      await this.hangfireService.startStopHangfireECSService();
      this.messageService.add(Message.Success('Start/Stop Request Received', 'Success'));
    } catch (e) {
      this.messageService.add(
        Message.Error(`Could not Start/Stop Hangfire ECS Service (${e})`, 'Error'),
      );
    } finally {
      this.modifyHangfireECSServiceDisabled = false;
    }
  }

  async getHangfireECSServiceOverview() {
    await this.hangfireService.getHangfireECSServiceOverview().then((results) => {
      this.hangfireECSServiceOverview = results;
    });
  }

  async getHangfireECSTaskCount() {
    await this.hangfireService.getHangfireECSTaskCount().then((result) => {
      this.hangfireECSCurrentTaskCount = result;
    });
  }

  trimFractionalSeconds(timeString: string): string {
    return timeString.split('.')[0];
  }
}
